import React, { useEffect, useState } from "react";

/**
 * Lightweight floating sparkle / gold-dust particles using CSS only.
 * Respects prefers-reduced-motion (the CSS animation is disabled globally there).
 */
export default function Sparkles({ count = 22, className = "" }) {
  const [items] = useState(() =>
    Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: 4 + Math.random() * 8,
      delay: Math.random() * 4,
      duration: 2 + Math.random() * 4,
      opacity: 0.4 + Math.random() * 0.5,
    }))
  );

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      data-testid="sparkles-layer"
    >
      {items.map((s) => (
        <span
          key={s.id}
          className="absolute animate-sparkle"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            opacity: s.opacity,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
            background:
              "radial-gradient(circle, rgba(252,246,186,1) 0%, rgba(212,175,55,0.6) 45%, rgba(212,175,55,0) 70%)",
            borderRadius: "50%",
            filter: "blur(0.4px)",
          }}
        />
      ))}
    </div>
  );
}
